import Countdown from "react-countdown";

function CountdownComponentSimple({date, serverTime, setServerTime, clientTime, setClientTime, onComplete}){
    const handleNow = () => {
        return serverTime;
    }
    const onTick = () =>{
        let now = Date.now();
        setServerTime(serverTime + (now - clientTime))
        setClientTime(now)
    }

    const renderer = ({ hours, minutes, seconds,completed }) => {
        return <span>{hours < 10 ? `0${hours}` : hours}:{minutes < 10 ? `0${minutes}` : minutes}:{seconds < 10 ? `0${seconds}` : seconds}</span>        
    };

    return(
        <Countdown 
            date={date} 
            renderer={renderer} 
            onTick={onTick}
            now={handleNow}
            onComplete={onComplete ? onComplete : ()=>{}}
        />
    )

}

export default CountdownComponentSimple